import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisUnlicensedRoute: InvariantJiraRoute = {
	name: 'polaris-unlicensed',
	path: '/jira/polaris/unlicensed',
	exact: true,
};
